import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitojaipurtaxi() {



const cardData = {
  keyword: " Mumbai to Jaipur Taxi",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Jaipur taxi services for travelers seeking a safe and convenient journey from Maharashtra to Rajasthan. Whether you are planning a leisure trip, family vacation, business travel, or group tour, our cab service ensures a smooth and hassle-free ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Jaipur taxi services.",

topPlaces: [
  {
    title: "Amber Fort",
    description:
      "Amber Fort is a magnificent hilltop fort near Jaipur, showcasing Rajput architecture, intricate carvings, and stunning courtyards. Visitors can enjoy elephant rides, guided tours, and panoramic views of Maota Lake. Traveling by taxi ensures a comfortable journey from Mumbai and provides ample time to explore the fort and its surroundings thoroughly."
  },
  {
    title: "City Palace",
    description:
      "City Palace is an iconic palace complex in Jaipur featuring museums, courtyards, and royal residences. Visitors can admire the architectural grandeur, learn about Jaipur's royal history, and take photographs. A taxi ride provides hassle-free access, allowing tourists to include this heritage site in their sightseeing itinerary efficiently."
  },
  {
    title: "Hawa Mahal",
    description:
      "Hawa Mahal, also known as the Palace of Winds, is a unique five-story structure with intricate latticework allowing cool breezes throughout. Visitors can capture photographs, explore the exterior, and enjoy the bustling markets nearby. Traveling by taxi ensures easy and comfortable access from Mumbai, enabling tourists to plan multiple attractions in a day."
  },
  {
    title: "Jantar Mantar",
    description:
      "Jantar Mantar is an astronomical observatory featuring historical instruments for measuring time, predicting eclipses, and tracking celestial bodies. Visitors can explore the observatory, learn about ancient science, and take photographs. A taxi service ensures convenient transport from Mumbai, making it easy to include in Jaipur sightseeing."
  },
  {
    title: "Nahargarh Fort",
    description:
      "Nahargarh Fort offers stunning views of Jaipur city, historical architecture, and trekking opportunities. Visitors can enjoy photography, sunset views, and explore fortifications. Traveling by taxi ensures a comfortable journey, allowing sufficient time to enjoy the fort and surrounding landscapes."
  },
  {
    title: "Jaigarh Fort",
    description:
      "Jaigarh Fort is known for its massive cannon, historic architecture, and panoramic views of Amber Fort and surrounding hills. Visitors can explore the fort, enjoy photography, and learn about its historical significance. A taxi ride from Mumbai provides hassle-free access, making it easier to plan a full day of sightseeing."
  },
  {
    title: "Albert Hall Museum",
    description:
      "Albert Hall Museum is a prominent museum in Jaipur showcasing art, sculptures, textiles, and historical artifacts. Visitors can explore galleries, enjoy photography, and learn about Rajasthan's rich heritage. Traveling by taxi ensures comfortable access and enough time to appreciate the exhibits."
  },
  {
    title: "Birla Mandir Jaipur",
    description:
      "Birla Mandir is a beautiful modern temple dedicated to Lord Vishnu and Goddess Lakshmi, known for its white marble architecture and serene atmosphere. Visitors can perform rituals, enjoy peaceful surroundings, and capture photographs. A taxi ride ensures hassle-free travel from Mumbai for spiritual and cultural exploration."
  },
  {
    title: "Chokhi Dhani",
    description:
      "Chokhi Dhani is a cultural village resort offering Rajasthani food, folk performances, crafts, and traditional experiences. Visitors can enjoy cultural shows, local cuisine, and shopping for handicrafts. Traveling by taxi ensures easy access, allowing tourists to combine cultural experiences with sightseeing efficiently."
  },
  {
    title: "Johari Bazaar",
    description:
      "Johari Bazaar is a bustling market famous for jewelry, textiles, handicrafts, and souvenirs. Visitors can shop, explore local culture, and enjoy street food. A taxi ride provides convenient transport from Mumbai, allowing tourists to integrate shopping with sightseeing and cultural exploration."
  }
],




services: [
{
name: "Mumbai to Jaipur Cab",
description: "Mumbai to Jaipur cab service offers comfortable and reliable interstate transportation between Maharashtra and Rajasthan. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth long-distance highway journeys. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for business travel, tourism trips, and family journeys. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Jaipur Taxi",
description: "Mumbai to Jaipur taxi service provides dependable road transportation for travelers planning interstate journeys. Comfortable AC vehicles ensure pleasant long-distance travel across major national highways. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family visits, and tourism travel. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure schedules allow passengers to plan trips easily. Reliable taxi services ensure smooth and safe intercity travel."
},
{
name: "Mumbai to Jaipur Cab Service",
description: "Mumbai to Jaipur cab service offers reliable transportation for passengers traveling between two major cities. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, tourism trips, and family visits. Spacious interiors ensure comfortable seating for long-distance journeys. Flexible booking options allow passengers to schedule trips easily. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai to Jaipur Taxi Service",
description: "Mumbai to Jaipur taxi service offers convenient and comfortable road travel for passengers planning interstate trips. Our fleet includes AC sedans and SUVs suitable for long-distance journeys. Skilled drivers ensure safe highway driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, families, and tourists. Spacious seating ensures passenger comfort throughout the journey. Flexible travel schedules allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Jaipur",
description: "Cab from Mumbai to Jaipur offers private and comfortable transportation for travelers seeking long-distance travel solutions. AC vehicles ensure smooth and relaxed highway journeys throughout the trip. Professional drivers ensure safe driving and reliable travel services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers, families, and tourists. Spacious interiors provide comfortable seating for extended journeys. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Jaipur",
description: "Taxi from Mumbai to Jaipur provides dependable road travel for passengers visiting the historic capital city of Rajasthan. Comfortable AC vehicles ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourism travel, business visits, and family trips. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling options allow easy travel planning. Professional taxi services ensure reliable intercity transportation."
},
{
name: "Mumbai to Jaipur Cab Booking",
description: "Mumbai to Jaipur cab booking allows passengers to reserve vehicles easily for interstate travel. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, tourism trips, and family visits. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel planning."
},
{
name: "Mumbai to Jaipur Taxi Booking Online",
description: "Mumbai to Jaipur taxi booking online provides quick and convenient reservations for passengers planning long-distance travel. Instant booking confirmation helps travelers schedule trips easily. Comfortable AC vehicles ensure relaxed highway travel conditions. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Jaipur Cab Price",
description: "Mumbai to Jaipur cab price offers transparent and affordable travel options for passengers planning interstate journeys. Clear pricing details allow travelers to understand total trip costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Jaipur Taxi Fare",
description: "Mumbai to Jaipur taxi fare is calculated using transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth interstate highway travel between the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips and family travel. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Jaipur One Way Cab",
description: "Mumbai to Jaipur one way cab service is ideal for travelers who require drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway journeys. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, relocation trips, and personal journeys. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
}
],

tableData: [
["Mumbai to Jaipur Cab","Mumbai to Jaipur Taxi"],
["Mumbai to Jaipur Cab Service","Mumbai to Jaipur Taxi Service"],
["Cab from Mumbai to Jaipur","Taxi from Mumbai to Jaipur"],
["Mumbai to Jaipur Cab Booking","Mumbai to Jaipur Taxi Booking Online"],
["Mumbai to Jaipur Cab Price","Mumbai to Jaipur Taxi Fare"],
["Mumbai to Jaipur One Way Cab","Best Cab Mumbai to Jaipur"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in handling long-distance routes like Mumbai to Jaipur. They are familiar with major highways, toll plazas, and state border routes, ensuring a safe and smooth intercity journey."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Jaipur taxi bookings. We clearly explain per-kilometer charges, toll fees, and driver allowances before confirming your booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Whether you want to start your journey early morning or travel overnight, Omshree Cabs provides 24/7 taxi booking and customer support for Mumbai to Jaipur travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, fully air-conditioned vehicles that are regularly cleaned and sanitized to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel options including one-way taxis, round-trip bookings, and multi-day travel plans so travelers can customize their Mumbai to Jaipur journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for families, business travelers, and group trips."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your journey to Jaipur begins smoothly and comfortably."
  },
  {
    WhyChooseheading: "Reliable Intercity Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for long-distance cab journeys. Our punctual drivers, comfortable vehicles, and professional service ensure a safe and reliable travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Jaipur by taxi?", answer: "The distance from Mumbai to Jaipur is approximately 1150 km and the journey usually takes around 18–20 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Jaipur taxi services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip taxi services between Mumbai and Jaipur." },
  { question: "Which vehicles are available for Mumbai to Jaipur travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Jaipur taxi bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide overnight travel services?", answer: "Yes, many travelers prefer overnight cab journeys and our experienced drivers ensure safe night travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for long-distance routes like Mumbai to Jaipur." },
  { question: "Do you provide corporate cab services to Jaipur?", answer: "Yes, Omshree Cabs provides corporate and business taxi services from Mumbai to Jaipur." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Jaipur trip. The driver was very professional and the vehicle was comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Singh",
    feedback:
      "Our family trip from Mumbai to Jaipur with Omshree Cabs was excellent. Clean car, smooth driving, and transparent pricing made the journey enjoyable.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Taxi",
  "description": "Book Mumbai to Jaipur Taxi with Omshree Cab for safe and comfortable outstation travel. Reliable cab service from Mumbai to Jaipur with options for one-way trips. Affordable fares, easy online booking, and trusted taxi service for your Jaipur journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai to Jaipur Taxi | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Jaipur Taxi with Omshree Cab for comfortable travel. Taxi service from Mumbai to Jaipur with one-way options. Affordable fares and easy online cab booking for your Jaipur trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurtaxi;